module.exports = __webpack_public_path__ + "img/ws.a34cfaa0.svg";